document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-photo-carousel]').forEach((root) => {
    const thumbs = root.querySelectorAll('[data-carousel-thumb]');
    const mains = root.querySelectorAll('[data-carousel-main]');
    const captions = root.querySelectorAll('[data-carousel-caption]');
 
    const setActive = (index) => {
      thumbs.forEach((el) => {
        const active = el.dataset.index === String(index);
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      mains.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === String(index));
      });
      captions.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === String(index));
      });
    };
 
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActive(thumb.dataset.index));
    });
 
    // 矢印キーでサムネイル間を移動できるようにしておく
    root.addEventListener('keydown', (event) => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const current = root.querySelector('[data-carousel-thumb].is-active');
      if (!current) return;
      const list = Array.from(thumbs);
      const idx = list.indexOf(current);
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      const nextIdx = forward
        ? Math.min(idx + 1, list.length - 1)
        : Math.max(idx - 1, 0);
      if (nextIdx !== idx) {
        event.preventDefault();
        list[nextIdx].focus();
        setActive(list[nextIdx].dataset.index);
      }
    });
  });
});